<template>
  <div class="common">
    <a-tabs v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name" >
        <keep-alive v-if="tabCur==item.key">
          <component 
          :is="item.comp" 
          :tabType="item.key"
          :status="item.status"
          ></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import fundingMain from "@/pages/account/funding-main"
const systemDate = window.sessionStorage.getItem('systemDate') || new Date();
export default {
  components: {
    fundingMain
  },
  name:"founding",
  data() {
    return {
      tabData:[
        {
          name:"收支明细",
          key:"detailsCol",
          comp:fundingMain,
          status:"1",
        },
        {
          name:"冻结/解冻明细",
          key:"frozenCol",
          comp:fundingMain,
          status:"2"
        },
        {
          name:"回单明细",
          key:"receiptCol",
          comp:fundingMain,
          status:"3"
        }
      ],
      tabCur:"detailsCol"
    }
  },
  computed:{
    ...mapGetters({
        userObj:"home/getUserObj"

    }),
  },
  created() {
    if(this.$route.params && this.$route.params.tabCur){
      this.tabCur = this.$route.params.tabCur;
    }
  },
  mounted() {
    
  },
  methods: {
    
    
  },
  activated() {

  },
  watch:{
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/account/funding.vue